export  enum ApplicationType {
    Both = 0,
    Evaadagai = 1,
    PrivateEvaadagai = 2,
    PACCSEvaadagai = 3 
}


